import { Helmet } from 'react-helmet'
import { Route, Switch } from 'react-router-dom'

/* Constants */
import { ROUTES } from '../../lib/constants'

/* Components */
import DeliveriesList from './DeliveriesList'
import DeliveryForm from './DeliveryForm'

export const Deliveries = () => (
  <>
    <Helmet>
      <title>POAP - Manage Deliveries</title>
      <meta property="og:title" content="POAP - Manage Deliveries" />
    </Helmet>
    <Switch>
      <Route exact path={ROUTES.deliveries.newForm.path} component={DeliveryForm} />
      <Route exact path={ROUTES.deliveries.editForm.path} component={DeliveryForm} />
      <Route exact path={ROUTES.deliveries.admin.path} component={DeliveriesList} />
    </Switch>
  </>
)
